import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import _EXT_Integrante from "../../Componentes/Compuestos/Complejos/Clientes/EXT_Integrante"
import { PaginaExterna } from "../../Componentes/Compuestos/Paginas/PaginaExterna";

export const _EXT_Reservas_Integrante = () => {

  const { CodigoCompania, CodigoEmpresa, CodigoPlanta, IdCliente, IdReserva } = useParams();

  useEffect(() => {

  }, []);


  return (

    <div>
      <PaginaExterna
        CodigoCompania={CodigoCompania} 
        CodigoEmpresa={CodigoEmpresa}
        CodigoPlanta={CodigoPlanta} >
        <_EXT_Integrante
          CodigoCompania={CodigoCompania}
          CodigoEmpresa={CodigoEmpresa}
          CodigoPlanta={CodigoPlanta}
          IdCliente={IdCliente}
          IdReserva={IdReserva} />
      </PaginaExterna>
    </div>
  );
};
